export default {
  teamEvents: {
    header: {
      title: 'Teamevent finden und buchen',
      description:
        'Über {eventCount} Kurse und Erlebnisse als Teamevent, Firmenevent oder Betriebsfeier. Von 10 bis 1.000 Personen.',
      buttonLabel: 'Anfrage senden oder anrufen: 030/692011960',
    },

    button: {
      label: 'Event anfragen',
      boxLabel: 'Boxen anfragen',
    },
  },
}
